import { useState } from "react";

const Decodefiche = () => {
  const [file, setFile] = useState(null);
  const [response, setResponse] = useState("");

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) return alert("Veuillez sélectionner une image.");
    
    const formData = new FormData();
    formData.append("image", file);

    try {
      const res = await fetch("http://localhost:8000/api/analyze-image", {
        method: "POST",
        body: formData,
      });

      const data = await res.json();
      setResponse(data.description);
    } catch (error) {
      console.error("Erreur:", error);
      setResponse("Erreur lors de l'analyse de l'image.");
    }
  };

  return (
    <div>
      <input type="file" onChange={handleFileChange} accept="image/*" />
      <button onClick={handleUpload}>Envoyer</button>
      {response && <p>Résultat : {response}</p>}
    </div>
  );
};

export default Decodefiche;
